import { initialize } from 'redux-form';
import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const VALIDATE_FORM_REQUEST = 'VALIDATE_FORM_REQUEST';
export const VALIDATE_FORM_SUCCESS = 'VALIDATE_FORM_SUCCESS';
export const VALIDATE_FORM_FAILURE = 'VALIDATE_FORM_FAILURE';

function requestValidateForm(formId) {
  return {
    type: VALIDATE_FORM_REQUEST,
    isValidatingForm: true,
    formId
  };
}

function receiveValidateForm(validationResult) {
  return {
    type: VALIDATE_FORM_SUCCESS,
    isValidatingForm: false,
    validationResult,
    validationFormError: null
  };
}

function rejectValidateForm(validationFormError) {
  return {
    type: VALIDATE_FORM_FAILURE,
    isValidatingForm: false,
    validationFormError
  };
}

function getFormName(formType) {
  let reduxFormName = '';
  if (formType) {
    let formName = formType;
    const splitIndex = formType.lastIndexOf('_');
    if (splitIndex > -1) {
      formName = formType.substring(0, splitIndex);
    }
    reduxFormName = `${ formName }-form`;
  }
  return reduxFormName;
}

export function validateForm(formType, formId, formData) {
  return (dispatch) => {
    dispatch(requestValidateForm(formId));

    const promise = () => ApiService
      .validateForm(formType, formId, formData)
      .then((response) => {
        dispatch(receiveValidateForm(response.data));
        dispatch(initialize(getFormName(formType), formData, false));
      })
      .catch((error) => {
        if (!error.reponse && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (!error.reponse || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectValidateForm, true, false));
        }
      });

    return promise();
  };
}
